import { opportunityGetters, seeMoreGetters } from './routines'

export default {
  [opportunityGetters.OPPORTUNITY_LIST]: state => state.opportunityList,
  [seeMoreGetters.SEE_MORE]: state => state.seeMore
}
